import ENV from "../env";

const createParticipant = async (
  eventId,
  tickets,
  details,
  subdivision,
  paid = false,
  promoCodeId = null,
  promoCodeUsageIncrement = 0,
) => {
  const firstName = details.find((field) => field.name.toLowerCase() === "firstname")?.value || "";
  const name = details.find((field) => field.name.toLowerCase() === "name")?.value || "";

  const response = await fetch(`${ENV.firebaseApiUrl}/participant/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      createdAt: new Date().valueOf().toString(),
      eventId,
      tickets,
      details,
      paid: paid,
      subdivision,
      fullName: `${firstName} ${name}`.trim(),
      promoCodeId,
      promoCodeUsageIncrement,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    const errorMessage = resData?.error || resData?.message || "Unknown error";
    throw Object.assign(new Error("Create participant failed: " + errorMessage), { code: resData.code, max: resData.max, ticketName: resData.ticketName });
  }

  return resData.participantId;
};

export default createParticipant;
